import { Alert, Button, Card, Col, DatePicker, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as actions from "../../actions";
import BasicLayout from "../../components/layout/index";
import "./index.less";

const Add = (props) => {
  const [form] = Form.useForm();
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const scheduleId = props.match.params.schedule_id;

  const defaultValues = {
    video_link: "",
    file_link: "",
    class_date: "",
  };

  useEffect(() => {
    form.setFieldsValue(defaultValues);
  }, [form, defaultValues]);

  const onFinish = (values) => {
    const data = {
      ...values,
    };

    props
      .addClassBlockDate({ schedule_id: scheduleId, ...data })
      .then((resp) => {
        if (resp.data && resp.data.status) {
          props.history.push("/admin/teacher-schedules");
        } else if (resp.err && !resp.err.status) {
          setError(true);
          setErrorMessage(resp.err.message);
        }
      })
      .catch((_err) => {
        setError(true);
        setErrorMessage("Something went wrong!");
      });
  };

  const onAlertClose = () => {
    setError(false);
  };

  return (
    <BasicLayout>
      <Row>
        <Col className="teacher-schedule-edit-container" span={12}>
          <Card className="teacher-schedule-edit-card">
            {isError && (
              <Alert
                message="Error"
                description={errorMessage}
                type="error"
                closable
                onClose={onAlertClose}
              />
            )}
            <Form
              form={form}
              size="large"
              layout="vertical"
              onFinish={onFinish}
              className="page-edit-teacher-schedule"
              initialValues={defaultValues}
            >
              <Form.Item
                name="class_date"
                label="Class Date"
                className="teacher-schedule-edit-label"
                rules={[
                  {
                    required: true,
                    message: "Please enter block date",
                  },
                ]}
              >
                <DatePicker placeholder={"Class Date"} />
              </Form.Item>
              <Form.Item
                name="block_reason"
                label="Block reason/note"
                className="teacher-schedule-edit-label"
              >
                <Input
                  className="teacher-schedule-edit-input"
                  placeholder="Enter Block reason/note"
                />
              </Form.Item>
              <Button htmlType="submit" type="primary">
                Block date
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    </BasicLayout>
  );
};

export default connect(
  (state) => ({
    isLoggedIn: state.isLoggedIn,
    admin: state.adminInfo,
  }),
  (dispatch) => bindActionCreators({ ...actions }, dispatch)
)(withRouter(Add));
